import React from 'react';
import { jumpTo } from '@/navigate'
import Tips from "../../components/tips";
import BgAudio from "./bgAudio";
import { inject, observer } from 'mobx-react';
import RuiQi from '../ruiqi';
import FeiWu from '../feiwu';
import './index.scss';
@inject('ScoreStore')
@observer
class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dragView: "",
            moveTarget: ""
        }
        this.moveStart = false;
        this.up = () => { this.mouseUp() }
        this.move = (e) => { this.mouseMove(e) }
    }

    componentDidMount() {
        this.initDragOverRange();
        this.tongRender();
    }
    initDragOverRange() {
        let dragView = this.refs.drag_view.getBoundingClientRect();
        this.setState({
            dragView
        })
    }
    mouseDown(e) {
        this.moveStart = true;
        let moveTarget = e.currentTarget;
        this.setState({
            moveTarget: moveTarget
        })
        let client = moveTarget.getBoundingClientRect();
        let x = e.clientX - this.state.dragView.left - client.width / 2;
        let y = e.clientY - this.state.dragView.top - client.height / 2;
        moveTarget.style.position = "absolute";
        moveTarget.style.top = y + "px";
        moveTarget.style.left = x + "px";
        window.addEventListener("mouseup", this.up, false)
        window.addEventListener("mousemove", this.move, false)
    }
    mouseMove(e) {
        if (!this.moveStart) {
            return false;
        }
        let moveTarget = this.state.moveTarget;
        let client = moveTarget.getBoundingClientRect();
        let x = e.clientX - this.state.dragView.left - client.width / 2;
        let y = e.clientY - this.state.dragView.top - client.height / 2;
        moveTarget.style.top = y + "px";
        moveTarget.style.left = x + "px";
        let result = this.isInRange(moveTarget);
        if (result.RangeName == "ruiqi") {
            this.RangeName = "ruiqi";
            this.ruiqi.onMouseMove()
            this.feiwu.onMouseOut()

        }
        else if (result.RangeName == "feiwu") {
            this.RangeName = "feiwu";
            this.feiwu.onMouseMove()
            this.ruiqi.onMouseOut()
        }
        else {
            if (this.RangeName) {
                if (this.RangeName == "ruiqi") {
                    this.ruiqi.onMouseOut()
                }
                else {
                    this.feiwu.onMouseOut()
                }
            }
        }
    }
    mouseUp() {
        this.moveStart = false;
        let moveTarget = this.state.moveTarget;
        let result = this.isInRange(moveTarget);
        if (result) {
            if (result.score) {
                this.props.ScoreStore.addScore(0.5);
            }
            else {
                this.props.ScoreStore.setPenalties("医疗废物处理", 0.5)
            }
            if (result.RangeName == "ruiqi") {
                this.ruiqi.onMouseOut()
            }
            else {
                this.feiwu.onMouseOut()
            }
            moveTarget.style.display = "none";
        }
        else {
            moveTarget.style.position = "relative";
            moveTarget.style.top = "0px";
            moveTarget.style.left = "0px";
        }
    }
    isInRange(moveTarget) {
        let reiView = this.refs.rei_view;
        let reiViewLS = reiView.offsetLeft;
        let reiViewLE = reiView.offsetLeft + reiView.offsetWidth;
        let reiViewTS = reiView.offsetTop;
        let reiViewTE = reiView.offsetTop + reiView.offsetHeight;
        let feiView = this.refs.fei_view;
        let feiViewLS = feiView.offsetLeft;
        let feiViewLE = feiView.offsetLeft + feiView.offsetWidth;
        let feiViewTS = feiView.offsetTop;
        let feiViewTE = feiView.offsetTop + feiView.offsetHeight;
        let left = parseInt(moveTarget.style.left)
        let top = parseInt(moveTarget.style.top)
        if ((left > reiViewLS && left < reiViewLE && top > reiViewTS && top < reiViewTE) || (left > feiViewLS && left < feiViewLE && top > feiViewTS && top < feiViewTE)) {
            let id = moveTarget.id;
            if (left > reiViewLS && left < reiViewLE && top > reiViewTS && top < reiViewTE) {
                if (id == "zhen") {
                    return { inRange: true, score: true, RangeName: "ruiqi" }
                }
                else {
                    return { inRange: true, score: false, RangeName: "ruiqi" }
                }

            }
            if (left > feiViewLS && left < feiViewLE && top > feiViewTS && top < feiViewTE) {
                if (id == "mianqiu" || id == "mianqian") {
                    return { inRange: true, score: true, RangeName: "feiwu" }
                }
                else {
                    return { inRange: true, score: false, RangeName: "feiwu" }
                }
            }
            return { inRange: true, score: false }
        }
        else {
            return false;
        }
    }
    jumpPage() {
        if (this.refs.zhen.style.display != "none") {
            this.props.ScoreStore.setPenalties("医疗废物处理", 0.5)
        }
        if (this.refs.mianqiu.style.display != "none") {
            this.props.ScoreStore.setPenalties("医疗废物处理", 0.5)
        }
        if (this.refs.mianqian.style.display != "none") {
            this.props.ScoreStore.setPenalties("医疗废物处理", 0.5)
        }
        window.removeEventListener("mouseup", this.up, false)
        window.removeEventListener("mousemove", this.move, false)

        jumpTo("guide9")
    }
    tongRender() {
        let rui = new RuiQi();
        rui.init(this.refs.rei_view);
        this.ruiqi = rui;
        let fei = new FeiWu();
        fei.init(this.refs.fei_view);
        this.feiwu = fei;
    }
    render() {
        return (
            <div className="page page-guide guide_room_2">
                <div className="form_view" ref={"drag_view"} id="drag_view">
                    <div className="form_tit tit_l">医疗废物处理</div>
                    <div className="throw_view">
                        <div className="throw_type">
                            <div className="type_item">
                                <div className="type_icon"><i className="icon icon_zhen" ref="zhen" id="zhen" onMouseDown={(e) => { this.mouseDown(e) }}></i></div>
                                <div>针</div>
                            </div>
                            <div className="type_item">
                                <div className="type_icon"><i className="icon icon_mianqiu" ref="mianqiu" id="mianqiu" onMouseDown={(e) => { this.mouseDown(e) }}></i></div>
                                <div>棉球</div>
                            </div>
                            <div className="type_item">
                                <div className="type_icon"><i className="icon icon_mianqian" ref="mianqian" id="mianqian" onMouseDown={(e) => { this.mouseDown(e) }}></i></div>
                                <div>棉签</div>
                            </div>
                        </div>
                        <div className="throw_away">
                            <div className="away_item">
                                <div className="away_icon" ref={"rei_view"}></div>
                                {/* <div className="away_icon" id={"rei_view"}><img src={require("../../assets/images/icon_ruiqi.png")} /></div> */}
                                <div>锐器垃圾桶</div>
                            </div>
                            <div className="away_item">
                                <div className="away_icon" ref={"fei_view"}></div>
                                {/* <div className="away_icon" id={"fei_view"}><img src={require("../../assets/images/icon_feiwu.png")} /></div> */}
                                <div>医疗废物</div>
                            </div>
                        </div>
                    </div>
                    <div className="form_btn txt_c">
                        <button onClick={() => { this.jumpPage() }}>完成</button>
                    </div>
                </div>
                <audio src={require("../../assets/audio/step_8.mp3")} autoPlay={true} />
                <Tips init={false} studyTips={4} />
                <BgAudio />
            </div>
        );
    }
}

export default App;
